var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-input-base-text',_vm._b({attrs:{"on-input":_vm.formatDown,"is-invalid":_vm.isInvalid,"type":'text',"inputmode":"numeric","pattern":"\\\\d*"},on:{"input":_vm.inputHandler}},'ui-input-base-text',{ ..._vm.model },false))
}
var staticRenderFns = []

export { render, staticRenderFns }